export default {
  clientId: ["sphere_mobile", "sphere_web"],
  entry: () => import("./main"),
};
